import { find, includes } from 'lodash'
import { Environment, RTKQuery } from '@core/constants'

export const checkValidUrl = (value: string) => {
    try {
        const url = new URL(value)
        return url
    } catch {
        return false
    }
}

export const extractUrlDetails = (url: string) => {
    const urlObject = new URL(url, Environment.BASE_URL)

    const urlWithoutParams = urlObject.origin + urlObject.pathname

    const params = new URLSearchParams(urlObject.search.replace('?', ''))
    const paramsAsObject = Object.fromEntries(params.entries())

    return {
        url: urlWithoutParams,
        params: paramsAsObject,
        path: urlObject.pathname,
    }
}

export const checkIsEndpointIgnored = (
    endpoint: string,
    statusCode: number,
) => {
    const path = extractUrlDetails(endpoint).path

    const ignoredEndpoint = find(RTKQuery.ignoredEndpoints, item => {
        return typeof item.pattern === 'string'
            ? item.pattern === path
            : item.pattern.test(path)
    })

    const isIgnoredEndpointsWithStatusCode =
        ignoredEndpoint?.statusCodes === '*' ||
        includes(ignoredEndpoint?.statusCodes, statusCode)

    return Boolean(isIgnoredEndpointsWithStatusCode)
}

export const checkValidBaseUrl = (url: string) => {
    return url.includes('alternatif.app') || url.includes('macellan.app')
}

export const resolveParamByBaseUrl = (url: string, params: string[]) => {
    if (!checkValidBaseUrl(url)) return url

    const extracted = extractUrlDetails(url)
    const resultParam = find(params, param => !!extracted.params[param])

    return resultParam ? extracted.params[resultParam] : url
}

export default {
    checkValidUrl: checkValidUrl,
    extractUrlDetails: extractUrlDetails,
    checkIsEndpointIgnored: checkIsEndpointIgnored,
    checkValidBaseUrl: checkValidBaseUrl,
    resolveParamByBaseUrl: resolveParamByBaseUrl,
}
